export const POLICY_ICON_SIZE = 24;

export const POLICY_ICON_PROPS = {
  width: POLICY_ICON_SIZE,
  height: POLICY_ICON_SIZE,
};
